module.exports = __webpack_public_path__ + "fonts/1972135.woff";